import { render, staticRenderFns } from "./CreatePackageDialog.vue?vue&type=template&id=20f7fe41&"
import script from "./CreatePackageDialog.vue?vue&type=script&lang=js&"
export * from "./CreatePackageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports